<div
  class="d-flex align-items-center justify-content-between p-7 mt-5 footer-fixed"
  [class.footer-shadow]="hasShadowFn() || this.hasShadow"
>
  <div class="col-2">
    @if (backUrl) {
      <a [routerLink]="backUrl" [queryParams]="backQueryParams" class="d-flex align-items-center td-none">
        <lib-elux-icon icon="Chevron_Left.svg" size="24" />
        <span class="ms-3 heading-3 c-blue">{{ backText }}</span>
      </a>
    } @else {
      <a (click)="backEvent.emit()" class="d-flex align-items-center td-none c-pointer">
        <lib-elux-icon icon="Chevron_Left.svg" size="24" />
        <span class="ms-3 heading-3 c-blue">{{ backText }}</span>
      </a>
    }
  </div>

  <div class="col-3 d-flex align-items-center justify-content-end gap-3">
    @if (draftText) {
      <lib-elux-button
        class="flex-1"
        [content]="draftText"
        type="outline"
        [loading]="draftLoading"
        (onClick)="draftEvent.emit()"
      />
    } @else {
      <div class="flex-1"></div>
    }
    <lib-elux-button
      class="flex-1"
      [disabled]="nextDisabled"
      [content]="nextText"
      type="basic"
      (onClick)="nextEvent.emit()"
      [loading]="nextLoading"
    />
  </div>
</div>
